import React from 'react'
import './index.css'
import SquadPageYourSuperLikedSamples from 'pages/Squad/containers/Friends/YourSuperLikedSamples'
import SquadPageYourLikedSamples from 'pages/Squad/containers/Friends/YourLikedSamples'
import SquadPageYourDislikedSamples from 'pages/Squad/containers/Friends/YourDislikedSamples'
import SquadPageYouVeRatedSamplesAcrossOrders from 'pages/Squad/containers/Friends/YouVeRatedSamplesAcrossOrders'
import useSelector from 'hooks/use-selector'
import getCurrentMemberIdSquadSelect from 'modules/squad/redux/selectors/get-current-member-id'
import hasLoadedAllProductsOrHasProductsByMemberIdSquadSelector from 'modules/squad/redux/selectors/has-loaded-all-current-member-products-or-has-products'

export default function SquadYourInfo () {
  const currentMemberId = useSelector(getCurrentMemberIdSquadSelect)
  const hasLoadedCurrentMemberProducts = useSelector(hasLoadedAllProductsOrHasProductsByMemberIdSquadSelector(currentMemberId))
  const debugProps = {
    hasLoadedCurrentMemberProducts
  }
  logUtil('SquadYourInfo').debug('[start] debugProps=', debugProps)

  if (!hasLoadedCurrentMemberProducts) {
    return <></>
  }

  return (
    <>
      <SquadPageYouVeRatedSamplesAcrossOrders />
      <SquadPageYourSuperLikedSamples />
      <SquadPageYourLikedSamples />
      <SquadPageYourDislikedSamples />
    </>
  )
}
